import * as React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

type SearchFieldProps = React.ComponentProps<typeof SearchField>

interface Props {
  onSearch: SearchFieldProps['onSearch']
  search: SearchFieldProps['search']
}

const SearchBar = ({ onSearch, search }: Props) => {
  return (
    <Box width="full">
      <SearchField
        variant="big"
        onSearch={onSearch}
        search={search}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )
}

export default observer(SearchBar)
